<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/trabajador-store';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/Trabajadores/Edicion/Formulario.svelte";

    onMount(() => store.nuevo());

    let error;
    $: error = $store.error;
</script>

<svelte:head>
    <title>Nuevo trabajador</title>
</svelte:head>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }
</style>

<Migas>
    <Miga url={$url('/trabajadores')}>Trabajadores</Miga>
    <Miga actual>Nuevo trabajador</Miga>
</Migas>

<Titulo>Nuevo trabajador</Titulo>

{#if $store.cargando}
    <Loading/>
{:else}
    {#if error}
        <Error mensaje={error} on:cancel={() => error = null}/>
    {:else }
        <Formulario titulo="Datos del nuevo trabajador" on:enviado={() => $goto('/trabajadores')}/>
    {/if}
{/if}